import React, { useState } from 'react';
import Button from 'components/form/Button';
import { InputWithoutControl } from 'components/form/Input';
import { substring } from 'helpers';

interface Props {
  text: string;
}

const CopyComponent = ({ text }: Props) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyText = () => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1500); // Reset copied state after 1.5s
  };
  return (
    <>
      <InputWithoutControl
        type="text"
        value={substring(text, 20)}
        readOnly
        endIcon={
          <Button
            className="text-brand-blue font-semibold"
            onClick={handleCopyText}
          >
            {isCopied ? (
              <span className="text-green-500">Copied!</span>
            ) : (
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"
                  />
                </svg>
              </span>
            )}
          </Button>
        }
        containerClass="w-fit bg-white rounded-md brand-border-light brand-shadow focus:outline-none focus-within:border-brand-blue dark:bg-brand-dark-200 bg-white"
        className="w-full bg-white text-sm"
      />
    </>
  );
};

export default CopyComponent;
